export default "__VITE_ASSET__4CdyABhm__"